module.exports = __webpack_public_path__ + "media/3_25.19e17644.wav";